<template>
  <div class="novw-todo-page">
    <!-- 顶部Tab导航 -->
    <div class="novw-tab-nav">
      <div
        v-for="(tab, index) in tabs"
        :key="index"
        class="novw-tab-item"
        :class="{ active: activeTab === index }"
        @click="handleTabClick(index)"
      >
        <span class="novw-tab-text">{{ tab.name }}</span>
        <span v-if="tab.count > 0" class="novw-tab-count" :class="{ 'novw-tab-count-red': index === 0 }">{{ tab.count }}</span>
      </div>
    </div>

    <!-- 分类筛选标签 -->
    <div class="novw-category-filter">
      <div
        v-for="(cat, index) in categories"
        :key="index"
        class="novw-category-item"
        :class="{ active: activeCategory === index }"
        @click="handleCategoryClick(index)"
      >
        <span>{{ cat.name }}</span>
        <span v-if="cat.count > 0" class="novw-category-count">{{ cat.count }}</span>
      </div>
    </div>

    <!-- 搜索栏 -->
    <div class="novw-search-bar">
      <input
        v-model="searchKeyword"
        type="text"
        class="novw-search-input"
        placeholder="搜索标题/申请人/审批单名称"
      />
      <button class="novw-search-btn" @click="handleSearch">搜索</button>
      <!-- <button class="novw-create-btn" @click="handleCreate">+ 创建待办</button> -->
    </div>

    <!-- 排序选项：按系统 / 按时间 / 按公司 / 按类型 / 按优先级 -->
    <div class="novw-sort-bar">
      <div
        v-for="opt in sortOptions"
        :key="opt.key"
        class="novw-sort-item"
        :class="{ active: sortBy === opt.key }"
        @click="handleSortClick(opt.key)"
      >
        <span>{{ opt.label }}</span>
        <span v-if="sortBy === opt.key" class="novw-sort-arrow">{{ sortOrder === 'asc' ? '↑' : '↓' }}</span>
      </div>
    </div>

    <!-- 加载状态 -->
    <div v-if="loading" class="novw-loading">加载中...</div>

    <!-- 待办列表 -->
    <div class="novw-todo-list">
      <div v-for="item in todoList" :key="item.taskId || item.processInstanceId" class="novw-todo-card">
        <div class="novw-card-left">
          <input
            type="checkbox"
            class="novw-card-checkbox"
            :checked="selectedIds.includes(item.taskId)"
            @change="handleItemSelect(item.taskId)"
          />
        </div>
        <div class="novw-card-content">
          <div class="novw-card-header">
            <div class="novw-card-title">
              <span class="novw-source-tag" :class="'novw-source-' + item.source">{{ getSourceLabel(item.source) }}</span>
              <span v-if="getBizField(item, 'type')" class="novw-type-tag">【{{ getBizField(item, 'type') }}】</span>
              <span class="novw-title-text">{{ item.title }}</span>
            </div>
            <div class="novw-card-actions">
              <span v-if="getBizField(item, 'approver')" class="novw-approver">当前审批人：{{ getBizField(item, 'approver') }}</span>
              <button v-if="item.pcUrl || getBizField(item, 'pcUrl')" class="novw-btn-detail" @click="handleViewDetail(item)">查看详情</button>
              <button class="novw-btn-approve" @click="handleApprove(item)">同意</button>
              <button class="novw-btn-reject" @click="handleReject(item)">拒绝</button>
            </div>
          </div>
          <div class="novw-card-detail">
            <span v-if="getBizField(item, 'priority')" class="novw-detail-item">优先级: {{ getBizField(item, 'priority') }}</span>
            <span v-if="item.originatorName || getBizField(item, 'applicant')" class="novw-detail-item">申请人: {{ item.originatorName || getBizField(item, 'applicant') }}</span>
            <span v-if="item.createdTime || getBizField(item, 'applyTime')" class="novw-detail-item">申请时间: {{ item.createdTime || getBizField(item, 'applyTime') }}</span>
            <span v-if="getBizField(item, 'amount')" class="novw-detail-item">金额: {{ getBizField(item, 'amount') }}</span>
            <span v-if="getBizField(item, 'quantity')" class="novw-detail-item">{{ getBizField(item, 'quantityLabel') || '数量' }}: {{ getBizField(item, 'quantity') }}</span>
            <span v-if="getBizField(item, 'duration')" class="novw-detail-item">总时长: {{ getBizField(item, 'duration') }}</span>
            <span v-if="item.deptName || getBizField(item, 'department')" class="novw-detail-item">部门: {{ item.deptName || getBizField(item, 'department') }}</span>
            <span v-if="getBizField(item, 'costCenter')" class="novw-detail-item">成本中心: {{ getBizField(item, 'costCenter') }}</span>
          </div>
          <div class="novw-card-tags">
            <span v-if="item.bizTag" class="novw-tag-item">{{ item.bizTag }}</span>
            <span v-for="(tag, idx) in getBizField(item, 'tags') || []" :key="idx" class="novw-tag-item">{{ tag }}</span>
          </div>
        </div>
      </div>
      <!-- 空状态 -->
      <div v-if="!loading && todoList.length === 0" class="novw-empty">暂无待办事项</div>
    </div>

    <!-- 底部操作栏 -->
    <div class="novw-bottom-bar">
      <div class="novw-bottom-row">
        <div class="novw-select-area">
          <input
            type="checkbox"
            class="novw-select-checkbox"
            :checked="isAllSelected"
            @change="handleSelectAll"
          />
          <span class="novw-select-label">全选</span>
        </div>
        <div class="novw-batch-actions">
          <button class="novw-btn-batch-approve" @click="handleBatchApprove">批量同意</button>
          <button class="novw-btn-batch-reject" @click="handleBatchReject">批量拒绝</button>
        </div>
      </div>
      <div class="novw-bottom-row">
        <span class="novw-total-info">共 {{ todoList.length }} 条待办</span>
      </div>
    </div>

    <!-- 同意/拒绝弹窗 -->
    <div v-if="dialogVisible" class="novw-dialog-mask" @click.self="closeDialog">
      <div class="novw-dialog-box novw-dialog-wide">
        <div class="novw-dialog-header">
          <span class="novw-dialog-title">{{ dialogType === 'approve' ? '同意' : '拒绝' }}审批</span>
          <span class="novw-dialog-close" @click="closeDialog">&times;</span>
        </div>
        <div class="novw-dialog-body">
          <!-- 业务数据展示（置灰只读） -->
          <div v-if="currentItem && !isBatch" class="novw-biz-data">
            <div class="novw-biz-title">待办详情</div>
            <div class="novw-biz-grid">
              <div class="novw-biz-item">
                <span class="novw-biz-label">标题</span>
                <span class="novw-biz-value">{{ currentItem.title || '--' }}</span>
              </div>
              <div class="novw-biz-item">
                <span class="novw-biz-label">渠道</span>
                <span class="novw-biz-value">{{ getSourceLabel(currentItem.source) || '--' }}</span>
              </div>
              <div class="novw-biz-item">
                <span class="novw-biz-label">类型</span>
                <span class="novw-biz-value">{{ getBizField(currentItem, 'type') || '--' }}</span>
              </div>
              <div class="novw-biz-item">
                <span class="novw-biz-label">优先级</span>
                <span class="novw-biz-value">{{ getBizField(currentItem, 'priority') || '--' }}</span>
              </div>
              <div class="novw-biz-item">
                <span class="novw-biz-label">申请人</span>
                <span class="novw-biz-value">{{ currentItem.originatorName || getBizField(currentItem, 'applicant') || '--' }}</span>
              </div>
              <div class="novw-biz-item">
                <span class="novw-biz-label">申请时间</span>
                <span class="novw-biz-value">{{ currentItem.createdTime || getBizField(currentItem, 'applyTime') || '--' }}</span>
              </div>
              <div class="novw-biz-item">
                <span class="novw-biz-label">审批人</span>
                <span class="novw-biz-value">{{ getBizField(currentItem, 'approver') || '--' }}</span>
              </div>
              <div class="novw-biz-item">
                <span class="novw-biz-label">成本中心</span>
                <span class="novw-biz-value">{{ getBizField(currentItem, 'costCenter') || '--' }}</span>
              </div>
              <div v-if="getBizField(currentItem, 'amount')" class="novw-biz-item">
                <span class="novw-biz-label">金额</span>
                <span class="novw-biz-value">{{ getBizField(currentItem, 'amount') }}</span>
              </div>
              <div v-if="getBizField(currentItem, 'quantity')" class="novw-biz-item">
                <span class="novw-biz-label">{{ getBizField(currentItem, 'quantityLabel') || '数量' }}</span>
                <span class="novw-biz-value">{{ getBizField(currentItem, 'quantity') }}</span>
              </div>
              <div v-if="getBizField(currentItem, 'duration')" class="novw-biz-item">
                <span class="novw-biz-label">时长</span>
                <span class="novw-biz-value">{{ getBizField(currentItem, 'duration') }}</span>
              </div>
              <div v-if="currentItem.deptName || getBizField(currentItem, 'department')" class="novw-biz-item">
                <span class="novw-biz-label">部门</span>
                <span class="novw-biz-value">{{ currentItem.deptName || getBizField(currentItem, 'department') }}</span>
              </div>
              <div v-if="getBizField(currentItem, 'remark')" class="novw-biz-item novw-biz-item-full">
                <span class="novw-biz-label">备注</span>
                <span class="novw-biz-value">{{ getBizField(currentItem, 'remark') }}</span>
              </div>
            </div>
          </div>
          <!-- 批量操作提示 -->
          <div v-if="isBatch" class="novw-batch-tip">
            已选择 {{ selectedIds.length }} 条待办
          </div>
          <!-- 理由输入 -->
          <div class="novw-reason-section">
            <div class="novw-reason-label">{{ dialogType === 'approve' ? '同意' : '拒绝' }}理由</div>
            <textarea
              v-model="dialogReason"
              class="novw-dialog-textarea"
              :placeholder="dialogType === 'approve' ? '请输入同意理由' : '请输入拒绝理由'"
            ></textarea>
          </div>
        </div>
        <div class="novw-dialog-footer">
          <button class="novw-dialog-btn novw-cancel" @click="closeDialog">取消</button>
          <button class="novw-dialog-btn novw-confirm" @click="confirmDialog">确认</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTodoList } from '@/api/nb'

// POC 固定用户ID
const FIXED_USER_ID = '02263737240426434576'

export default {
  name: 'TodoPage',
  data() {
    return {
      loading: false,
      // Tab导航
      activeTab: 0,
      tabs: [
        { name: '待我处理', count: 0 },
        { name: '我已处理', count: 0 },
        { name: '已阅', count: 0 },
        { name: '我发起的', count: 0 },
        { name: '抄送我的', count: 0 }
      ],
      // 分类筛选（写死，不做筛选功能）
      activeCategory: 0,
      categories: [
        { name: '所有', count: 0 },
        { name: '行政', count: 0 },
        { name: '人事', count: 0 }
      ],
      // 搜索
      searchKeyword: '',
      // 排序：sortBy 为 '' | 'source' | 'time' | 'company' | 'type' | 'priority'
      sortBy: '',
      sortOrder: 'desc',
      sortOptions: [
        { key: 'source', label: '按系统' },
        { key: 'time', label: '按时间' },
        { key: 'company', label: '按公司' },
        { key: 'type', label: '按类型' },
        { key: 'priority', label: '按优先级' }
      ],
      // 待办列表（原始数据）
      allTodoList: [],
      // 选中项
      selectedIds: [],
      // 弹窗
      dialogVisible: false,
      dialogType: 'approve',
      dialogReason: '',
      currentItem: null,
      isBatch: false
    }
  },
  mounted() {
    // 读取 query 参数设置 activeTab
    const tab = this.$route.query.tab
    if (tab !== undefined) {
      const tabIndex = parseInt(tab, 10)
      if (!isNaN(tabIndex) && tabIndex >= 0 && tabIndex < this.tabs.length) {
        this.activeTab = tabIndex
      }
    }
    // 加载待办列表
    this.fetchTodoList()
  },
  computed: {
    // 待办列表（根据 sortBy/sortOrder 排序）
    todoList() {
      const list = [...this.allTodoList]
      if (!this.sortBy) return list
      const order = this.sortOrder === 'asc' ? 1 : -1
      list.sort((a, b) => {
        const va = this.getSortValue(a, this.sortBy)
        const vb = this.getSortValue(b, this.sortBy)
        if (va == null && vb == null) return 0
        if (va == null) return order
        if (vb == null) return -order
        if (typeof va === 'string' && typeof vb === 'string') {
          return order * (va.localeCompare(vb, 'zh-CN'))
        }
        if (typeof va === 'number' && typeof vb === 'number') return order * (va - vb)
        const sa = String(va)
        const sb = String(vb)
        return order * sa.localeCompare(sb, 'zh-CN')
      })
      return list
    },
    isAllSelected() {
      return this.todoList.length > 0 && this.todoList.every(item => this.selectedIds.includes(item.taskId))
    }
  },
  methods: {
    // 获取待办列表
    async fetchTodoList() {
      this.loading = true
      try {
        const res = await getTodoList(FIXED_USER_ID)
        if (res.success && res.data && res.data.todoList) {
          this.allTodoList = res.data.todoList
          this.updateCounts()
        }
      } catch (err) {
        console.error('获取待办列表失败:', err)
      } finally {
        this.loading = false
      }
    },
    // 更新计数
    updateCounts() {
      const list = this.allTodoList
      this.tabs[0].count = list.length
      this.categories[0].count = list.length
    },
    // 获取渠道显示名称
    getSourceLabel(source) {
      const labels = { ORG: '三方', YIDA: '宜搭', OA: 'OA' }
      return labels[source] || source
    },
    // 从 bizData 获取字段值
    getBizField(item, field) {
      if (item.bizData && item.bizData[field] !== undefined) {
        return item.bizData[field]
      }
      return null
    },
    // 获取用于排序的字段值（系统/时间/公司/类型/优先级）
    getSortValue(item, key) {
      switch (key) {
        case 'source':
          return item.source || ''
        case 'time':
          return item.createdTime || this.getBizField(item, 'applyTime') || ''
        case 'company':
          return this.getBizField(item, 'company') || ''
        case 'type':
          return this.getBizField(item, 'type') || ''
        case 'priority':
          return this.getBizField(item, 'priority') || ''
        default:
          return null
      }
    },
    // 点击排序项：同一项切换升序/降序，不同项则切换并默认降序
    handleSortClick(key) {
      if (this.sortBy === key) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc'
      } else {
        this.sortBy = key
        this.sortOrder = key === 'time' ? 'desc' : 'asc'
      }
    },
    handleTabClick(index) {
      this.activeTab = index
    },
    handleCategoryClick(index) {
      this.activeCategory = index
    },
    handleSearch() {
      console.log('搜索关键词:', this.searchKeyword)
    },
    handleCreate() {
      this.$router.push('/todo/create')
    },
    handleItemSelect(id) {
      const index = this.selectedIds.indexOf(id)
      if (index > -1) {
        this.selectedIds.splice(index, 1)
      } else {
        this.selectedIds.push(id)
      }
    },
    handleSelectAll() {
      if (this.isAllSelected) {
        this.selectedIds = []
      } else {
        this.selectedIds = this.todoList.map(item => item.taskId)
      }
    },
    handleApprove(item) {
      this.currentItem = item
      this.dialogType = 'approve'
      this.dialogReason = ''
      this.isBatch = false
      this.dialogVisible = true
    },
    handleViewDetail(item) {
      const url = item.pcUrl || this.getBizField(item, 'pcUrl')
      if (url) {
        window.open(url, '_blank')
      }
    },
    handleReject(item) {
      this.currentItem = item
      this.dialogType = 'reject'
      this.dialogReason = ''
      this.isBatch = false
      this.dialogVisible = true
    },
    handleBatchApprove() {
      if (this.selectedIds.length === 0) {
        alert('请先选择待办项')
        return
      }
      this.dialogType = 'approve'
      this.dialogReason = ''
      this.isBatch = true
      this.dialogVisible = true
    },
    handleBatchReject() {
      if (this.selectedIds.length === 0) {
        alert('请先选择待办项')
        return
      }
      this.dialogType = 'reject'
      this.dialogReason = ''
      this.isBatch = true
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
      this.dialogReason = ''
      this.currentItem = null
    },
    confirmDialog() {
      if (!this.dialogReason.trim()) {
        alert('请输入理由')
        return
      }
      if (this.isBatch) {
        console.log(`批量${this.dialogType === 'approve' ? '同意' : '拒绝'}:`, this.selectedIds, '理由:', this.dialogReason)
      } else {
        console.log(`${this.dialogType === 'approve' ? '同意' : '拒绝'}:`, this.currentItem, '理由:', this.dialogReason)
      }
      this.closeDialog()
    }
  }
}
</script>

<style lang="less" scoped>
.novw-todo-page {
  width: 100%;
  min-height: 100vh;
  background: #fff;
  padding: 20px 40px;
  padding-bottom: 120px;
  box-sizing: border-box;
}

/* Tab导航 */
.novw-tab-nav {
  display: flex;
  align-items: center;
  gap: 40px;
  border-bottom: 1px solid #e8e8e8;
  padding-bottom: 12px;
  margin-bottom: 20px;
}

.novw-tab-item {
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  padding-bottom: 12px;
  margin-bottom: -13px;
  border-bottom: 2px solid transparent;

  &.active {
    border-bottom-color: #2E5BFF;

    .novw-tab-text {
      color: #2E5BFF;
    }
  }
}

.novw-tab-text {
  font-size: 14px;
  color: #666;
}

.novw-tab-count {
  display: inline-block;
  min-width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  font-size: 12px;
  color: #666;
  background: #f0f0f0;
  border-radius: 50%;

  &.novw-tab-count-red {
    color: #ff4d4f;
    background: #fff1f0;
  }
}

/* 分类筛选 */
.novw-category-filter {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.novw-category-item {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 16px;
  border-radius: 20px;
  border: 1px solid #d9d9d9;
  background: #fff;
  color: #666;
  font-size: 14px;
  cursor: pointer;

  &.active {
    background: #2E5BFF;
    border-color: #2E5BFF;
    color: #fff;

    .novw-category-count {
      display: inline-block;
      min-width: 18px;
      height: 18px;
      line-height: 18px;
      text-align: center;
      color: #fff;
      background: rgba(255, 255, 255, 0.3);
      border-radius: 50%;
    }
  }
}

.novw-category-count {
  font-size: 12px;
}

/* 搜索栏 */
.novw-search-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.novw-search-input {
  width: 280px;
  height: 32px;
  padding: 0 12px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 14px;
  outline: none;

  &::placeholder {
    color: #bfbfbf;
  }

  &:focus {
    border-color: #2E5BFF;
  }
}

.novw-search-btn {
  height: 36px;
  padding: 0 24px;
  background: #2E5BFF;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    background: #5A7FFF;
  }
}

.novw-create-btn {
  height: 36px;
  padding: 0 20px;
  background: #52c41a;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  margin-left: auto;

  &:hover {
    background: #73d13d;
  }
}

/* 排序栏：按系统 / 按时间 / 按公司 / 按类型 / 按优先级 */
.novw-sort-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 16px;
}

.novw-sort-item {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 14px;
  border-radius: 16px;
  border: 1px solid #d9d9d9;
  background: #fafafa;
  color: #666;
  font-size: 13px;
  cursor: pointer;

  &:hover {
    border-color: #2E5BFF;
    color: #2E5BFF;
  }

  &.active {
    background: #e6eeff;
    border-color: #2E5BFF;
    color: #2E5BFF;
  }
}

.novw-sort-arrow {
  font-size: 12px;
  opacity: 0.9;
}

/* 待办列表 */
.novw-todo-list {
  display: flex;
  flex-direction: column;
}

.novw-todo-card {
  display: flex;
  align-items: flex-start;
  padding: 20px 0;
  border-bottom: 1px solid #f0f0f0;
}

.novw-card-left {
  padding-right: 16px;
  padding-top: 4px;
}

.novw-card-checkbox {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.novw-card-content {
  flex: 1;
}

.novw-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.novw-card-title {
  display: flex;
  align-items: center;
}

.novw-type-tag {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.novw-title-text {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.novw-card-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.novw-approver {
  font-size: 14px;
  color: #666;
}

.novw-btn-approve {
  padding: 6px 20px;
  background: #2E5BFF;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    background: #5A7FFF;
  }
}

.novw-btn-reject {
  padding: 6px 20px;
  background: #ff4d4f;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    background: #ff7875;
  }
}

.novw-btn-detail {
  padding: 6px 20px;
  background: #fff;
  color: #52c41a;
  border: 1px solid #52c41a;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    background: #f6ffed;
  }
}

.novw-card-detail {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  margin-bottom: 12px;
}

.novw-detail-item {
  font-size: 14px;
  color: #999;
}

.novw-card-tags {
  display: flex;
  gap: 8px;
}

.novw-tag-item {
  padding: 4px 12px;
  background: #f5f5f5;
  color: #666;
  font-size: 12px;
  border-radius: 4px;
}

/* 底部操作栏 */
.novw-bottom-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  border-top: 1px solid #e8e8e8;
  padding: 12px 40px;
}

.novw-bottom-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
}

.novw-select-area {
  display: flex;
  align-items: center;
  gap: 8px;
}

.novw-select-checkbox {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.novw-select-label {
  font-size: 14px;
  color: #333;
}

.novw-batch-actions {
  display: flex;
  gap: 12px;
}

.novw-btn-batch-approve {
  padding: 6px 20px;
  background: #fff;
  color: #2E5BFF;
  border: 1px solid #2E5BFF;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    background: #EEF2FF;
  }
}

.novw-btn-batch-reject {
  padding: 6px 20px;
  background: #fff;
  color: #ff4d4f;
  border: 1px solid #ff4d4f;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    background: #fff2f0;
  }
}

.novw-pagination {
  display: flex;
  align-items: center;
  gap: 8px;
}

.novw-page-btn {
  width: 28px;
  height: 28px;
  background: transparent;
  border: none;
  color: #333;
  font-size: 14px;
  cursor: pointer;

  &:hover:not(:disabled) {
    color: #2E5BFF;
  }

  &:disabled {
    cursor: not-allowed;
    color: #d9d9d9;
  }
}

.novw-page-num {
  padding: 0 12px;
  font-size: 14px;
  color: #333;
}

.novw-page-info {
  font-size: 14px;
  color: #999;
  margin-left: 12px;
}

/* 弹窗 */
.novw-dialog-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.novw-dialog-box {
  width: 480px;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
}

.novw-dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid #f0f0f0;
}

.novw-dialog-title {
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

.novw-dialog-close {
  font-size: 20px;
  color: #999;
  cursor: pointer;

  &:hover {
    color: #666;
  }
}

.novw-dialog-body {
  padding: 24px;
}

.novw-dialog-textarea {
  width: 100%;
  height: 120px;
  padding: 12px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 14px;
  resize: none;
  outline: none;
  box-sizing: border-box;

  &::placeholder {
    color: #bfbfbf;
  }

  &:focus {
    border-color: #2E5BFF;
  }
}

.novw-dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid #f0f0f0;
}

.novw-dialog-btn {
  padding: 8px 24px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;

  &.novw-cancel {
    background: #fff;
    color: #333;
    border: 1px solid #d9d9d9;

    &:hover {
      border-color: #2E5BFF;
      color: #2E5BFF;
    }
  }

  &.novw-confirm {
    background: #2E5BFF;
    color: #fff;
    border: none;

    &:hover {
      background: #5A7FFF;
    }
  }
}

/* 加载状态 */
.novw-loading {
  text-align: center;
  padding: 40px 0;
  color: #999;
  font-size: 14px;
}

/* 空状态 */
.novw-empty {
  text-align: center;
  padding: 60px 0;
  color: #999;
  font-size: 14px;
}

/* 渠道标签 */
.novw-source-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  margin-right: 8px;
  font-weight: 500;
}

.novw-source-ORG {
  background: #e6f7ff;
  color: #1890ff;
}

.novw-source-YIDA {
  background: #f6ffed;
  color: #52c41a;
}

.novw-source-OA {
  background: #fff7e6;
  color: #fa8c16;
}

/* 总条数信息 */
.novw-total-info {
  font-size: 14px;
  color: #999;
}

/* 加宽弹窗 */
.novw-dialog-wide {
  width: 600px;
}

/* 业务数据展示区 */
.novw-biz-data {
  background: #f9f9f9;
  border-radius: 4px;
  padding: 16px;
  margin-bottom: 16px;
}

.novw-biz-title {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e8e8e8;
}

.novw-biz-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.novw-biz-item {
  display: flex;
  align-items: flex-start;
}

.novw-biz-item-full {
  grid-column: 1 / -1;
}

.novw-biz-label {
  width: 70px;
  flex-shrink: 0;
  font-size: 13px;
  color: #999;
}

.novw-biz-value {
  flex: 1;
  font-size: 13px;
  color: #666;
}

/* 批量操作提示 */
.novw-batch-tip {
  background: #e6f7ff;
  border: 1px solid #91d5ff;
  border-radius: 4px;
  padding: 12px 16px;
  margin-bottom: 16px;
  font-size: 14px;
  color: #1890ff;
}

/* 理由输入区 */
.novw-reason-section {
  margin-top: 8px;
}

.novw-reason-label {
  font-size: 14px;
  color: #333;
  margin-bottom: 8px;
}
</style>
